import React from 'react';
import Input from '../../../components/forms/Input';
import ImageUpload from '../../../components/forms/ImageUpload';

const PictureHeader = ({
    data,
    errors,
    title,
    onInput,
    disabled,
    imageField = 'image',
    nameLabel = 'Name *',
    nameField = 'name'
}) => (
    <div className="ckp-admin-forms-header">
        {title && <h1 className="ckp-ts-h1 u-margin-bottom-2">{title}</h1>}
        <div className="ckp-admin-grid-row">
            {!disabled && (
                <div className="ckp-admin-grid-column">
                    <ImageUpload onChange={onInput} name={imageField} value={data[imageField]} />
                </div>
            )}
            <div className="ckp-admin-grid-column u-vertical-center">
                <Input
                    disabled={disabled}
                    errorMessage={errors[nameField]}
                    label={nameLabel}
                    name={nameField}
                    onChange={onInput}
                    value={data[nameField]}
                />
            </div>
        </div>
    </div>
);

export default PictureHeader;



// WEBPACK FOOTER //
// ./src/components/admin/forms/PictureHeader.js